import React from "react";
import { Box } from "@mui/material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";

import Avatar from "../../../../Avatar";
import { createAvatarName, hasImage } from "../../../../../utils";

function NotificationEventAvatar({ actor, type, showUnreadDot }) {
  let icon = <NotificationsNoneOutlinedIcon className="notification-event-icon" />;

  if (type === "comment") {
    icon = <ChatBubbleOutlineRoundedIcon className="notification-event-icon" />;
  }

  if (type === "assignment") {
    icon = <AssignmentTurnedInOutlinedIcon className="notification-event-icon" />;
  }

  return (
    <Box className="notification-avatar-shell">
      {showUnreadDot ? <Box className="notification-avatar-dot" /> : null}
      <Avatar
        title={[actor?.first_name, actor?.last_name].filter(Boolean).join(" ")}
        username={actor?.first_name}
        user_image={actor?.user_image}
        className="notification-user-avatar"
        style={
          !hasImage(actor?.user_image)
            ? {
                bgcolor: "#eef4fb",
                color: "#436488",
              }
            : {}
        }
      >
        {createAvatarName(
          [actor?.first_name, actor?.last_name].filter(Boolean).join(" ")
        )}
      </Avatar>
      {/* <Box className="notification-event-badge">{icon}</Box> */}
    </Box>
  );
}

export default React.memo(NotificationEventAvatar);
